import { EstateResultItem, EstateResultItemType, EstateResultSource } from 'queries';

// id is a md5 hash of sourceName
export const sources: Array<Partial<EstateResultItem>> = [
  {
    essentialData: JSON.stringify({
      sourceName: 'Trustate Corporation',
      primaryAddress: '802 E. Whiting Street',
      cityName: 'Tampa',
      stateAbbreviation: 'FL',
      zipCode: '33602',
      telephoneNumber: '618-437-8283',
    }),
    createdAt: undefined,
    updatedAt: undefined,
    id: '2091f249e9dd2ce75838c7ae27be8bde',
    source: EstateResultSource.Trustate,
    type: EstateResultItemType.Source,
    title: 'Trustate Corporation',
    subtitle: '',
  },
  {
    essentialData: JSON.stringify({
      sourceName: 'Internal Revenue Service',
      primaryAddress: '1111 Constitution Ave',
      cityName: 'NW Washington',
      stateAbbreviation: 'DC',
      zipCode: '20224',
      telephoneNumber: '202-622-5000',
    }),
    createdAt: undefined,
    updatedAt: undefined,
    id: 'e03103e50fdb95a126add4d413ca7432',
    source: EstateResultSource.Trustate,
    type: EstateResultItemType.Source,
    title: 'Internal Revenue Service',
    subtitle: '',
  },
  {
    essentialData: JSON.stringify({
      sourceName: 'Envestnet Yodlee',
      primaryAddress: '999 Baker Way',
      secondaryAddress: 'Suite 100',
      cityName: 'San Mateo',
      stateAbbreviation: 'CA',
      zipCode: '94404',
      telephoneNumber: '650-980-3600',
    }),
    createdAt: undefined,
    updatedAt: undefined,
    id: 'c661148ac27b8aa0979dde162b2b1297',
    source: EstateResultSource.Trustate,
    type: EstateResultItemType.Source,
    title: 'Envestnet Yodlee',
    subtitle: '',
  },
];
